import { render, staticRenderFns } from "./giftTable.vue?vue&type=template&id=2dc3d64e&scoped=true"
import script from "./giftTable.vue?vue&type=script&lang=js"
export * from "./giftTable.vue?vue&type=script&lang=js"
import style0 from "./giftTable.vue?vue&type=style&index=0&id=2dc3d64e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc3d64e",
  null
  
)

export default component.exports